/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Items_FoundInputs */

const en_no_items_found = /** @type {(inputs: No_Items_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No items found`)
};

const nl_no_items_found = /** @type {(inputs: No_Items_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen items gevonden`)
};

/**
* | output |
* | --- |
* | "No items found" |
*
* @param {No_Items_FoundInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const no_items_found = /** @type {((inputs?: No_Items_FoundInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Items_FoundInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_no_items_found(inputs)
	return en_no_items_found(inputs)
});